import routers from "@/router/router";
import { getSideMenuByRouter, getBreadCrumbList } from "@/utils/util";
// console.log(routers);

export default {
  state: {
    breadCrumbList: []
  },
  mutations: {
    setBreadCrumb(state, route) {
      state.breadCrumbList = getBreadCrumbList(route);
    }
  },
  getters: {
    menuList(state, getters, rootState) {
      return getSideMenuByRouter(routers, rootState.user.permissionList);
    },
    breadCrumbList(state) {
      return state.breadCrumbList;
    }
  },
  actions: {}
};
